(function () {
  const reviewTextSelector = '.jdgm-prev-badge__text';

  function normalizeReviewText(text) {
    const cleanText = text.replace(/[()]/g, '').trim();
    if (!cleanText) return text;
    return `(${cleanText})`;
  }

  function formatReviewCounts(root = document) {
    root.querySelectorAll(reviewTextSelector).forEach((node) => {
      const text = node.textContent || '';
      const cleanText = text.trim();

      if (!cleanText || cleanText.startsWith('(')) return;

      node.textContent = normalizeReviewText(cleanText);
    });
  }

  document.addEventListener('DOMContentLoaded', () => formatReviewCounts());
  document.addEventListener('shopify:section:load', (event) => formatReviewCounts(event.target));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          formatReviewCounts(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
